// extracted by mini-css-extract-plugin
module.exports = {"bs1xkmi":"bs1xkmi","t1nikq00":"t1nikq00"};